export const SocketChannelNamespaceType = {
    CORE: "CORE",
    SYNC: "SYNC",
    PRIVATE: "PRIVATE",
    AI_ASSISTANT: "AI_ASSISTANT",
};
